import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { DateTime } from 'scaleflow/utils/date-time';
import valIsObject from 'scaleflow/utils/is-object';

export default class InitiativesFormsPlanningAndPeopleComponent extends Component {
  datePickerInstance = null;
  @service store;
  @service intl;

  get tippyOffset() {
    return [0, 8];
  }

  @action
  handleBlur(changeset) {
    //if page is not navigating away
    if (changeset.get('isPristine') === true) {
      this.isDisabled = true;
    } else if (changeset.get('isValid') === true) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  @action
  onDatePickerReady(e) {
    this.datePickerInstance = e;
  }

  @action
  openDatePicker() {
    this.datePickerInstance?.open();
  }

  @action
  handleDateChange(changeset, e) {
    changeset.set('startDate', DateTime.from(e).format('YYYY-MM-DD'));
  }

  get personsList() {
    const pm = this.args.changeset.productManager;
    const persons = this.store
      .peekAll('person')
      .filter((person) => person.active || pm?.get?.('id') === person.id)
      .map((item) => ({
        color: item.color,
        abbreviation: item.abbreviation,
        value: item.id,
        label: item.name,
      }));
    return persons;
  }

  @action
  handleSelect(changeset, field, model, e) {
    const record = this.store.peekRecord(model, e.value);
    changeset.set(field, record);
  }

  @action
  setTeams(changeset, e) {
    const teams = e.map((team_id) => this.store.peekRecord('team', team_id));
    changeset.set('teams', teams);
  }

  @action
  clearSelect(changeset, field) {
    changeset.set(field, null);
  }

  @action
  teamIds(changeset) {
    const teams = changeset.get('teams');
    const isObject = valIsObject(teams);
    const isPromise = !isObject ? false : 'promise' in teams;
    if (isPromise && !teams?.content) return [];
    if (isPromise && teams?.content)
      return teams?.content.map((team) => team.id);
    return changeset.get('teams').map((team) => team.id);
  }
}
